import * as R from 'ramda';
import { fromJS } from 'immutable';
import * as actions from '../actions/queuesetting';
import { fetchingState } from '@constants';
import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';

const initialState = fromJS({
  queues: {
    state: null,
    data: [],
  },
  queueWorkItems: {
    state: null,
    data: [],
    sortModel: [],
  },
  allUsers: [],
  attachments: [],
  properties: [],
  appeals: [],
  deeds: [],
  events: [],
  notes: [],
  buildingPermits: [],
  currentWorkItem: {},
  backWorkItem: {},
  copyAttachmentRunsPagination: {
    count: 0,
    page: 1,
    rowsPerPage: 1000,
    rowsPerPageOptions: [5, 10, 25, 50, 1000, 5000, 10000],
  },
  copyAttachmentRunWorkItemListPagination: {
    count: 0,
    page: 1,
    rowsPerPage: 1000,
    rowsPerPageOptions: [5, 10, 25, 50, 1000, 5000, 10000],
  },
  copyAttachmentRunWorkItemState: {}
});

const workTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_BACK_WORK_ITEM: {
      return state.set('backWorkItem', fromJS(action.data));
    }
    case actions.FETCH_QUEUES[SUCCESS]: {
      return state
        .setIn(['queues', 'state'], fetchingState.LOADED)

        .setIn(
          ['queues', 'data'],
          fromJS(R.pathOr([], ['data', 'results'])(action)),
        );
    }
    case actions.FETCH_QUEUES[START]: {
      return state.setIn(['queues', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_QUEUES[ERROR]: {
      return state.setIn(['queues', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_ALL_USERS[SUCCESS]: {
      return state.setIn(
        ['allUsers'],
        fromJS(R.pathOr([], ['data', 'results'])(action)),
      );
    }

    case actions.FETCH_QUEUE_WORK_ITEMS[SUCCESS]: {
      return state
        .setIn(['queueWorkItems', 'state'], fetchingState.LOADED)

        .setIn(
          ['queueWorkItems', 'data'],
          fromJS(R.pathOr([], ['data', 'results'])(action)),
        );
    }
    case actions.FETCH_QUEUE_WORK_ITEMS[START]: {
      return state.setIn(['queueWorkItems', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_QUEUE_WORK_ITEMS[ERROR]: {
      return state.setIn(['queueWorkItems', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_WORK_ITEM_ATTACHMENTS[SUCCESS]: {
      return state.setIn(
        ['attachments'],
        fromJS(R.pathOr([], ['data', 'results'])(action)),
      );
    }

    case actions.FETCH_WORK_ITEM_PROPERTIES[SUCCESS]: {
      return state.setIn(
        ['properties'],
        fromJS(R.pathOr([], ['data', 'results'])(action)),
      );
    }

    case actions.FETCH_WORK_ITEM_NOTES[SUCCESS]: {
      return state.setIn(
        ['notes'],
        fromJS(R.pathOr([], ['data', 'results'])(action)),
      );
    }

    case actions.FETCH_WORK_ITEM_APPEALS[SUCCESS]: {
      return state.setIn(
        ['appeals'],
        fromJS(R.pathOr([], ['data', 'results'])(action)),
      );
    }

    case actions.FETCH_WORK_ITEM_DEEDS[SUCCESS]: {
      return state.setIn(
        ['deeds'],
        fromJS(R.pathOr([], ['data', 'results'])(action)),
      );
    }

    case actions.FETCH_WORK_ITEM_EVENTS[SUCCESS]: {
      return state.setIn(
        ['events'],
        fromJS(R.pathOr([], ['data', 'results'])(action)),
      );
    }

    case actions.FETCH_WORK_ITEM_BUILDING_PERMITS[SUCCESS]: {
      return state.setIn(
        ['buildingPermits'],
        fromJS(R.pathOr([], ['data', 'results'])(action)),
      );
    }

    case actions.CHANGE_WORK_ITEM_ORDER[SUCCESS]: {
      return state.setIn(
        ['queueWorkItems', 'data'],
        fromJS(R.pathOr([], ['data', 'results'])(action)),
      );
    }

    case actions.FETCH_QUEUE_WORK_ITEM[SUCCESS]: {
      return state.setIn(
        ['currentWorkItem'],
        fromJS(R.pathOr([], ['data', 'results', 0])(action)),
      );
    }

    case actions.CHANGE_QUEUE_WORK_ITEMS_SORT_MODEL: {
      return state.setIn(['queueWorkItems', 'sortModel'], fromJS(action.payload));
    }

    case actions.FETCH_COPY_FINALIZED_WORK_ITEM_RUNS[START]: {
      return state
        .setIn(['copyAttachmentRunsPagination', 'page'], action.page)
        .setIn(['copyAttachmentRunsPagination', 'rowsPerPage'], action.pageSize);
    }
    case actions.FETCH_COPY_FINALIZED_WORK_ITEM_RUNS[SUCCESS]: {
      return state
        .setIn(['copyAttachmentRunsPagination', 'count'], action.data.totalRuns ?? 0);
    }
    case actions.CHANGE_RUNS_PAGE: {
      return state
        .setIn(['copyAttachmentRunsPagination', 'page'], action.payload);
    }
    case actions.CHANGE_RUNS_ROWS_PER_PAGE: {
      return state
        .setIn(['copyAttachmentRunsPagination', 'rowsPerPage'], action.payload);
    }
    case actions.CHANGE_RUN_LISTING_PAGE: {
      return state
        .setIn(['copyAttachmentRunWorkItemListPagination', 'page'], action.payload);
    }
    case actions.CHANGE_RUN_LISTING_ROWS_PER_PAGE: {
      return state
        .setIn(['copyAttachmentRunWorkItemListPagination', 'rowsPerPage'], action.payload);
    }
    case actions.SET_ATTACHMENT_DETAIL_WORKITEM: {
      return state
        .setIn(['copyAttachmentRunWorkItemState'], action.payload);
    }
    case actions.CLEAR_ATTACHMENT_DETAIL_WORKITEM: {
      return state
        .setIn(['copyAttachmentRunWorkItemState'], {});
    }

    default: {
      return state;
    }
  }
};

export default workTypesReducer;
